import React, { Component } from 'react';
import styled from '@emotion/styled';
import { t } from 'services/translation';

const ExpiryCvcContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  margin-top: 16px;
`;

const StripeFlexElement = styled('div')`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  margin-right: ${(props) => props.marginRight || 0};
  margin-left: ${(props) => props.marginLeft || 0};
`;

class StripeCardElement extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    errors: {},
  };

  stripe() {
    return this.props.stripe || window.stripe;
  }

  componentDidMount() {
    const { onMountCallback } = this.props;
    onMountCallback && onMountCallback();
  }

  stripeContainerClass(elementName) {
    const defaultContainerClass = 'ui input t-Default stripe-element';
    const errorClass = 'error';
    return this.getErrorFor(elementName)
      ? defaultContainerClass.concat(` ${errorClass}`)
      : defaultContainerClass;
  }

  getErrorFor(str) {
    const { errors } = this.props;
    if ('get' in errors) {
      return errors.get(str);
    }
    return errors[str];
  }

  render() {
    return (
      <React.Fragment>
        <label>{t('CARD_DETAILS')}</label>
        <div className={this.stripeContainerClass('cardNumber')}>
          <div id="stripe-card-element" />
          <span className="input-error">
            {this.getErrorFor('cardNumber') || ''}
          </span>
          <ExpiryCvcContainer>
            <StripeFlexElement
              className={this.stripeContainerClass('cardExpiry')}
              marginRight="8px"
            >
              <label>{t('EXPIRATION')}</label>
              <div id="stripe-expiry-element" />
              <span className="input-error">
                {this.getErrorFor('cardExpiry') || ''}
              </span>
            </StripeFlexElement>
            <StripeFlexElement
              className={this.stripeContainerClass('cardCvc')}
              marginLeft="8px"
            >
              <label>{t('SECURITY_CODE')}</label>
              <div id="stripe-cvc-element" />
              <span className="input-error">
                {this.getErrorFor('cardCvc') || ''}
              </span>
            </StripeFlexElement>
          </ExpiryCvcContainer>
        </div>
      </React.Fragment>
    );
  }
}

export { StripeCardElement };
